import script from "./Object1View.vue?vue&type=script&setup=true&lang=js"
export * from "./Object1View.vue?vue&type=script&setup=true&lang=js"

import "./Object1View.vue?vue&type=style&index=0&id=70510afb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70510afb"]])

export default __exports__